
const date = dateFormat();
const urlBase = `https://www.morningoffering.com/wp-json/mo/v1/today/${date}?type=`;

dailyOffering(`${urlBase}offering`);
dailyMeditation(`${urlBase}meditation`);
dailyPrayer(`${urlBase}prayer`);


function dateFormat() {
	// Get today's date and format appropriately
	const date = new Date();
	const result = date.toLocaleDateString("en-US", {
		month: "2-digit",
		day: "2-digit"
	});
	const dateFormat = result.replace("/", "");
	return dateFormat;
}


async function dailyOffering(fetchURL) {

	const offeringContainer = document.querySelector('.art-commentary__offering');

	try {

		const response = await fetch(fetchURL, {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		});

		if (response.ok) {

			const data = await response.json();

			if (data) {

				offeringContainer.innerHTML += `
					<div class="the-offering">
						<h2 class="h3">The Morning Offering</h2>
						${data.morning_offering}
					</div>
				`;

			} else {

				offeringContainer.innerHTML = "<p>No morning offering found.</p>";

			}

		} else {

			const error = 'Failed to get the Morning Offering.'
			console.error(error);
			offeringContainer.innerHTML = `<p>${error}</p>`;

		}

	} catch (error) {

		console.error("Error fetching data: ", error);
		offeringContainer.innerHTML = "<p>Error loading the Morning Offering.</p>";

	}
}


async function dailyMeditation(fetchURL) {

	const meditationContainer = document.querySelector('.art-commentary__meditation');

	try {

		const response = await fetch(fetchURL, {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		});

		if (response.ok) {

			const data = await response.json();

			if (data) {

				// Handleize the title
				const productTitle = data.meditation_credit.book_title;
				const handleTitle  = productTitle.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase(window.Shopify.locale).replace(/&/g, '-and-').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').replace(/-{2,}/g, '-');

				// Get the product data from Shopify
				const spResponse = await fetch(`/products/${handleTitle}.json`, {
					method: "GET",
					headers: { "Content-Type": "application/json" }
				});

				// If not ok, then use MO data
				if (spResponse.ok) {

					const spData = await spResponse.json();

					meditationContainer.innerHTML = `
						<div class="meditation">
							<h2 class="h3">Today's Meditation</h2>
							${data.meditation}
						</div>
						<product-card handle="${handleTitle}" class="product-card product-card--blends product-card--show-secondary-media bg-custom text-custom" style="--background: 255 255 255; --text-color: 47 47 47; opacity: 1; transform: translateY(0px);">
							<span class="h5">A Excerpt From</span>
							<div class="product-card__figure" style="margin-block-start: var(--spacing-1);">
								<a href="/products/${handleTitle}" data-instant="" class="product-cart__image-link">
									<img src="${spData.product.image.src}" alt="${spData.product.image.alt}" width="1" height="1" loading="lazy" class="product-card__image" fetchpriority="low" style="margin-block-start:var(--spacing-0-5);">
								</a>
							</div>

							<div class="product-card__info" style="margin-block-start: var(--spacing-2);--product-card-info-padding:0 var(--spacing-8) var(--spacing-8) var(--spacing-8)">
								<div class="v-stack gap-0.5 w-full">
									<div class="rating-with-text">
										<span class="product-card__title">
											<a href="/products/${handleTitle}" class="bold" data-instant="">${spData.product.title}</a>
										</span>
									</div>
									<price-list class="price-list">
										<sale-price class="text-subdued">
											<span class="sr-only">Sale price</span>
											$${spData.product.variants[0].price}
										</sale-price>
									</price-list>
								</div>
							</div>
						</product-card>
					`;


				} else {

					meditationContainer.innerHTML = `
						<div class="meditation">
							<h2 class="h3">Today's Meditation</h2>
							${data.meditation}
						</div>
						<div class="meditation--credit meditation--credit__mo">
							<img src="${data.meditation_credit.book_image_url}" alt="Product image of the '${productTitle}'" class="meditation--credit--img" width="1" height="1" loading="lazy" fetchpriority="low"/>
							<div class="meditation--credit-text">
								<span>A Excerpt From</span>
								<a href="${data.meditation_credit.book_purchase_url}" aria-label="See more about the '${productTitle}' product">${productTitle}</a>
							</div>
						</div>
					`;

				}

			} else {

				meditationContainer.innerHTML = `<p>No daily meditation found for ${result}.</p>`;

			}

		} else {

			const error = 'Failed to get the daily meditation.'
			console.error(error);
			offeringContainer.innerHTML = `<p>${error}</p>`;

		}

	} catch (error) {

		console.error("Error fetching data: ", error);
		meditationContainer.innerHTML = "<p>Error loading the daily meditation.</p>";

	}
}


async function dailyPrayer(fetchURL) {

	const prayerContainer = document.querySelector('.art-commentary__prayer');

	try {

		const response = await fetch(fetchURL, {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		});

		if (response.ok) {

			const data = await response.json();

			if (data) {

				prayerContainer.innerHTML = `
					${data.quote_text}
					<cite>${data.quote_author}</cite>
				`;

			} else {

				prayerContainer.innerHTML = `<p>No daily quote found for ${result}.</p>`;

			}

		} else {

			const error = 'Failed to get the daily prayer.'
			console.error(error);
			offeringContainer.innerHTML = `<p>${error}</p>`;

		}

	} catch (error) {

		console.error("Error fetching data: ", error);
		prayerContainer.innerHTML = "<p>Error loading the daily prayer.</p>";

	}
}
